import { combineReducers } from 'redux';
import { SCOPE, SCOPE_REQUEST } from './types';
import coreReducer from './reducer';
import distributionSagas from './sagas';
import { createReducer } from '@api/createRequestStore';

export { default as selectors } from './selectors';

export { SCOPE, SCOPE_REQUEST };

export const reducer = combineReducers({
  core: coreReducer,
  request: createReducer(SCOPE),
});

export const sagas = [...distributionSagas];
